import { StyledCol } from '@/shared/styles';
import styled from 'styled-components';

export const StyledUsersLayout = styled(StyledCol)`
  width: 100%;
  gap: 32px;
`;
